<script setup lang="ts">
import type { IFeatureItem, IPricingCardData } from '../../../models'
import PricingCard from './PricingCard.component.vue'

const lcid: string = <any>useAttrs().lcid
const footnotes: string[] = <any>useAttrs().footnotes
const cards: IPricingCardData[] = (useAttrs().cards || ([] as any)).filter((x: IFeatureItem) => !x.exclude)
</script>

<template>
  <div class="w-full flex flex-col">
    <div class="w-full flex flex-col items-center">
      <div
        class="isolate mx-auto grid max-w-md grid-cols-1 gap-8 md:mx-0 md:max-w-none md:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3"
      >
        <PricingCard v-for="card in cards" :key="`card-${card.position}`" :lcid="lcid" :model="card" />
      </div>
    </div>

    <div class="mt-12 text-sm italic">
      <ol>
        <li v-for="(note, ni) in footnotes" :key="note" :id="`fn_${ni + 1}`">
          {{ note }}
        </li>
      </ol>
    </div>
  </div>
</template>
